import _ from 'underscore';
import Api from '@/lib/api/api';
import v5_Collection from '@/collections/v5/collection';
import Deployment from '@/models/v5/deployment';

    function type_filter(type, deployment) {
        var devicegroup = deployment.rel.get('devicegroup');
        return devicegroup && devicegroup.type === type;
    }
    const collection = new v5_Collection();
    _.extend(collection, {
        model: Deployment,
        url: function(){
            return Api.urls.deployments();
        },
        filters : {
            production: _.partial(type_filter, 'production_devicegroup'),
            development: _.partial(type_filter, 'development_devicegroup'),
            factory: _.partial(type_filter, 'factory_devicegroup')
        },
        production_deployments : function(){
            return collection.filter(collection.filters.production);
        },
        development_deployments : function(){
            return collection.filter(collection.filters.development);
        },
        factory_deployments : function(){
            return collection.filter(collection.filters.factory);
        }
    });
    export default collection;

